import { Flex, HStack, Text } from '@chakra-ui/react'
import React from 'react'

export default function Table({
  data,
}: {
  data: { value: number; label: string }[]
}) {
  return (
    <HStack gap={6} mt={4}>
      {data
        .filter((nutrient) => nutrient.value && nutrient.value > 0)
        .map((nutrient, index) => (
          <Flex key={index} fontSize="sm" flexDir="column" gap={0}>
            <Text>{nutrient.value}</Text>
            <Text>{nutrient.label}</Text>
          </Flex>
        ))}
    </HStack>
  )
}
